import { render } from "./OpenClaw.vue?vue&type=template&id=350a4be8"
import script from "./OpenClaw.vue?vue&type=script&lang=js"
export * from "./OpenClaw.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__